import React from 'react';
import { FiCheck, FiShield } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const Pricing = () => {
  return (
    <section id="pricing" className="py-20 bg-brand-yellow">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto bg-brand-black rounded-2xl shadow-2xl overflow-hidden flex flex-col md:flex-row">
          
          <div className="p-10 md:w-2/3 flex flex-col justify-center">
            <h2 className="text-3xl font-bold text-white mb-4">Start Understanding Tonight</h2>
            <p className="text-gray-400 mb-6">
              Every day you spend guessing is another day of fights that could have been prevented.
            </p>
            
            <ul className="space-y-3 mb-8">
              {['100 translations that prevent misunderstandings', 'Exact scripts for what to say back', 'The dictionary nobody gave you', 'Instant PDF + EPUB Download'].map((item, i) => (
                <li key={i} className="flex items-center gap-3 text-gray-300">
                  <span className="bg-brand-yellow text-brand-black rounded-full p-1"><SafeIcon icon={FiCheck} size={12} /></span>
                  {item}
                </li>
              ))}
            </ul>

            <div className="flex flex-col gap-3">
              <span className="text-sm text-gray-500 line-through">Price increases to $14.99 soon</span>
              <a 
                href="https://link.nordiccrm.ca/payment-link/69ab87521e61210f3f78bc8a"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-brand-yellow text-brand-black w-full py-4 rounded-lg font-bold text-xl hover:bg-white transition-colors text-center"
              >
                GET THE BOOK — $9.99
              </a>
            </div>

            <p className="text-center text-gray-500 text-xs mt-4 flex items-center justify-center gap-2">
              <SafeIcon icon={FiShield} /> 30-day money-back guarantee. No questions asked.
            </p>
          </div>

          <div className="bg-brand-gray p-10 md:w-1/3 flex flex-col items-center justify-center text-center border-t md:border-t-0 md:border-l border-white/10">
            <p className="text-gray-400 text-sm mb-2">Less than...</p>
            <div className="space-y-4 w-full">
              <div className="bg-brand-black p-3 rounded border border-white/5 text-gray-300 text-sm">One therapy copay</div>
              <div className="bg-brand-black p-3 rounded border border-white/5 text-gray-300 text-sm">One date night</div>
              <div className="bg-brand-black p-3 rounded border border-white/5 text-gray-300 text-sm">One fight gone wrong</div>
            </div>
            <p className="text-brand-yellow font-bold mt-6 text-lg">Invest in peace.</p>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Pricing;